export interface IReportType {
  sort_report_type_id: number;
  report_type: string;
  sorters: string[];
}

export const GENERATETYPES = [
  'MONTHLY', 'QUARTER', 'YEARLY', 'MANUAL'
];

export const REPORTSTATUS = [
  'OK', 'FAIL', 'EMPTY'
];

export interface ISorter { // Käsittelijä
  name: string;
  id: string;
}

export interface ISortStation { // Käsittelyasema
  name: string;
  id: string;
  sorterId: string;
}

export interface ICollectionPoint { // Keräyspiste
  info: ICollectionPointInfo;
  crossreferences: ICrossReference[];
}

export interface IBasicCollectionPoint { // Keräyspiste, tiivis
  id: string;
  name: string;
}

export interface ICollectionPointInfo { // Keräyspisteen tiedot
  collectionpoint_id: string;
  operator_id: string;
  public_id: string;
  name: string;
  operational_state: string;
  location_lat: string;
  location_lon: string;
  street_address: string;
  zip_code: string;
  city: string;
  community: string;
  contact_info: string;
  dataser: boolean;
  store_point: boolean;
  container_point: boolean;
}

export interface ICrossReference { 
  sorter_name: string;
  references: string[];
}

export interface ICrossReferenceUpdate { 
  sorter_id: string;
  reference_string: string;
}

export interface ICollectionPointUpdate { // Keräyspisteen tietojen päivitys
  info: ICollectionPointInfo;
  crossreferences: ICrossReferenceUpdate[];
  collectionpoint_exists: boolean;
}

export interface ICollectionPointOperator { // Jätehuoltoyhtiö
  id: string;
  name: string;
  collection_points: ICollectionPoint[];
  autoemail: boolean;
  reportformat: string;
  emails: string[];
}

export interface ICollectionPointOperatorAdd { // Jätehuoltoyhtiön lisääminen
  id: string;
  name: string;
  collection_points: ICollectionPointUpdate[];
  autoemail: boolean;
  reportformat: string;
  emails: string[];
}

export interface ICollectionReporting { // Vastaanottoraportti
  sortStationId: string;
  manualReport: boolean;
  manualReportEmail: boolean;
  monthlyReport: boolean;
  monthlyReportEmail: boolean;
  lastReportType: 'monthly' | 'manual';
  lastReportDate: string;
  lastReportStatus:	'ok' | 'error' | 'empty';
}

export interface ISortCode {
  codeId: number;
  groupName: string;
  groupNameKey: string;
  kpCode: string;
  description: string;
  descriptionKey: string;
  containerSplitPercentage: number;
  transportSplitPercentage: number;
  splitGroup: string;
}

export interface IStore {
  sorters?: ISorter[];
  sortStations?: ISortStation[];
  collectionReporting?: ICollectionReporting[];
  collectionpointOperators?: ICollectionPointOperator[];
  collectionpoints?: ICollectionPoint[];
  backendversion?: string;
  sortCodes?: ISortCode[];
  reportTypes?: IReportType[];
}

export interface IHandlerData { // Käsittelytiedot
  sorter: ISorter;
  sortStation: ISortStation;
  collectionPoint: IBasicCollectionPoint;
  category: string;
  itemType: string;
  date: string;
  weight: string;
  transferdocumentId: string;
}

export interface IHandlerReportSummary { // Käsittelyraportti
  checksum: number;
  crt: number;
  sda: number;
  lda: number;
  cold: number;
  ce: number;
  solar: number;
  scrap: number;
  total: number;
}

export interface ISummaryReportOptions {
  optionsId?: number;
  ldaOpenContainerMonthlyCost: number;
  coolContainerMonthlyCost: number;
  sdaCeCrtContainerMonthlyCost: number;
  receivedMonthlyCostPerKilo: number;
  validityYear: string;
  created?: string;
  total?: number;
}

export interface ISummaryReportMetrics {
  'HANDLING': number;
  'RECEIVING': number;
  'CONTAINERS': number;
  'TRANSPORT': number;
}
export interface ISummaryReportTotals {
  'HANDLING': string;
  'RECEIVING': string;
  'CONTAINERS': string;
  'TRANSPORT': string;
  'KG': string;
  'FEE': string;
  'POM_KG': string;
}
export interface ISummaryReportClass {
  'KG' : string;
  'HANDLING_EUR': string;
  'RECEIVING_EUR': string;
  'CONTAINERS_EUR': string;
  'TRANSPORT_EUR': string;
  'TOTAL_EUR': string;
  'EUR/KG': string;
  'FEE': string;
  'POM_WEIGHT': string;
}
export interface ISummaryReportGrouping {
  [weeeGroup: string]: {
    [subClass: string]: string[];
  }
}
export interface ISummaryReportData {
  REPORTROWS: {
    [key: string]: ISummaryReportClass
  };
  METRICS: ISummaryReportMetrics;
  TOTALS: ISummaryReportTotals;
  REPORTGROUPING: ISummaryReportGrouping;
}